<svg
  class={$$props.class}
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.5 12.25L11 13.75L14.5 10.25M5 4H19C19.5523 4 20 4.44772 20 5V17.382C20 17.7607 19.786 18.107 19.4472 18.2764L12.4472 21.7764C12.1657 21.9172 11.8343 21.9172 11.5528 21.7764L4.55279 18.2764C4.214 18.107 4 17.7607 4 17.382V5C4 4.44772 4.44772 4 5 4Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
